// GENERATED FILE - DO NOT MODIFY

export enum UserTeamFilterModeDto {
    Members = "Members",
    Managers = "Managers",
    MembersAndManagers = "MembersAndManagers",
    MembersAndFavorites = "MembersAndFavorites",
    MembersManagersAndFavorites = "MembersManagersAndFavorites",
}